import { Stepper, TextInput } from '@atoms';
import { useLanguage } from '@languageProvider';
import { Spacing, Typography } from '@styles';
import { useTheme } from '@themeProvider';
import React from 'react';
import { Text, View } from 'react-native';
import { ImageBackground } from 'react-native-web';

export const AddDelivery = ({ value, setValue, showTitle }) => {
    const { useColor } = useTheme();
    const [body, title] = useColor(['body', 'title']);
    const { translate } = useLanguage();
    return (
        <View style={{ marginHorizontal: Spacing.M }}>
            {!!showTitle && <Text style={[Typography.TITLE, { color: title, textAlign: 'center', marginHorizontal: Spacing.XS }]}>{translate('deliveryModalTitle')}</Text>}
            <Text style={[Typography.BODY, { color: body, marginHorizontal: Spacing.XS, marginBottom: Spacing.M }]}>
                {translate('addDeliveryExplanation')}
            </Text>
            <TextInput
                label={translate('seating')}
                information={`${translate('eg')}: 17B`}
                {...{ value, setValue }} />
        </View>
    )
}

export const AddGlass = ({ value, setValue }) => {
    const { useColor } = useTheme();
    const [body, title, label] = useColor(['body', 'title', 'label']);
    const { translate } = useLanguage();
    return (
        <View style={{ marginHorizontal: Spacing.M }}>
            <Text style={[Typography.TITLE, { color: title, textAlign: 'center', marginHorizontal: Spacing.XS }]}>{translate('glassModalTitle')}</Text>
            <Text style={[Typography.BODY, { color: body, marginHorizontal: Spacing.XS, marginVertical: Spacing.M }]}>
                {translate('addGlassExplanation')}
            </Text>
            <Text style={[Typography.OVERLINE, [{ color: label, textAlign: 'center' }]]}>{translate('glasses')}</Text>
            <Stepper {...{ value, setValue, min: 0 }} />
        </View>
    )
}

export const UpsellingModal = ({ value, setValue, products, modalTitle = '', modalDescription = '' }) => {
    const { useColor } = useTheme();
    const [body, title, label, line] = useColor(['body', 'title', 'label', 'line']);
    const { translate } = useLanguage();

    const setQuantity = (id) => (quantity) => {
        setValue({ id, quantity });
    }

    const oneProduct = Object.keys(value).length <= 1;

    return (
        <View style={{ marginHorizontal: Spacing.M }}>
            <Text style={[Typography.TITLE, { color: title, textAlign: 'center', marginHorizontal: Spacing.XS }]}>{modalTitle}</Text>
            <Text style={[Typography.BODY, { color: body, marginHorizontal: Spacing.XS, marginVertical: Spacing.M, textAlign: 'center' }]}>
                {modalDescription}
            </Text>

            {
                Object.keys(value).map(selId => {
                    const { quantity } = value[selId];
                    return <View key={selId} style={{ gap: Spacing.XS }}>
                        <Text numberOfLines={2} style={[Typography.OVERLINE, [{ color: label, textAlign: 'center' }]]}>{products[selId].title}</Text>
                        <View style={{
                            flexDirection: oneProduct ? 'column' : 'row',
                            gap: Spacing.M,
                            justifyContent: 'center'
                        }}>
                            {!!products[selId].photo &&
                                <ImageBackground source={{ uri: products[selId].photo }} style={{
                                    width: oneProduct ? 88 : 44,
                                    height: oneProduct ? 88 : 44,
                                    alignSelf: oneProduct ? 'center' : 'stretch',
                                    marginLeft: oneProduct ? 0 : -60,
                                    borderRadius: 16, borderColor: line, borderWidth: 1,
                                    overflow: 'hidden'
                                }} />
                            }
                            <Stepper {...{ value: quantity, setValue: setQuantity(selId), min: 0 }} />
                        </View>
                    </View>
                })
            }

        </View>
    )
}
